import { render } from "./PersonaSwitcher.vue?vue&type=template&id=3b93e09b&scoped=true"
import script from "./PersonaSwitcher.vue?vue&type=script&lang=js"
export * from "./PersonaSwitcher.vue?vue&type=script&lang=js"

import "./PersonaSwitcher.vue?vue&type=style&index=0&id=3b93e09b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b93e09b"]])

export default __exports__